import { Controller } from "@hotwired/stimulus"

// Validates the checkout contact form on blur/input/submit. Shows inline
// error messages in the design language (via .field-error + .has-error).
export default class extends Controller {
  static targets = ["firstName", "lastName", "email", "phone", "submit"]
  static values = {
    emailPattern: { type: String, default: "^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$" },
    phonePattern: { type: String, default: "^[237-9]\\d{8}$" }
  }

  connect() {
    this.messages = {
      required: "Acest câmp este obligatoriu.",
      email: "Introdu o adresă de email validă.",
      phone: "Număr românesc invalid — 9 cifre, începând cu 7 (ex: 712 345 678).",
      nameShort: "Te rugăm să introduci numele complet."
    }
    this.emailRegex = new RegExp(this.emailPatternValue)
    this.phoneRegex = new RegExp(this.phonePatternValue)
    this.fields = [
      this.firstNameTarget,
      this.lastNameTarget,
      this.emailTarget,
      this.phoneTarget
    ]
    this.fields.forEach((field) => {
      field.addEventListener("blur", () => this.validateField(field))
      field.addEventListener("input", () => this.clearError(field))
    })
  }

  submit(event) {
    const firstInvalid = this.fields.find((f) => !this.validateField(f))
    if (firstInvalid) {
      event.preventDefault()
      firstInvalid.focus()
      firstInvalid.scrollIntoView({ behavior: "smooth", block: "center" })
    }
  }

  validateField(field) {
    const value = field.value.trim()
    let error = null

    if (value.length === 0) {
      error = this.messages.required
    } else if (field === this.emailTarget && !this.emailRegex.test(value)) {
      error = this.messages.email
    } else if (field === this.phoneTarget) {
      const digits = value.replace(/\D/g, "")
      if (!this.phoneRegex.test(digits) || digits.length !== 9) {
        error = this.messages.phone
      }
    } else if (
      (field === this.firstNameTarget || field === this.lastNameTarget) &&
      value.length < 2
    ) {
      error = this.messages.nameShort
    }

    if (error) {
      this.showError(field, error)
      return false
    }

    this.clearError(field)
    return true
  }

  showError(field, message) {
    const group = field.closest(".field-group")
    if (!group) return

    group.classList.add("has-error")
    field.setAttribute("aria-invalid", "true")

    let errorEl = group.querySelector(".field-error")
    if (!errorEl) {
      errorEl = document.createElement("p")
      errorEl.className = "field-error"
      errorEl.setAttribute("role", "alert")
      errorEl.id = `${field.id || field.name}-error`
      group.appendChild(errorEl)
      field.setAttribute("aria-describedby", errorEl.id)
    }
    errorEl.textContent = message
  }

  clearError(field) {
    const group = field.closest(".field-group")
    if (!group) return

    group.classList.remove("has-error")
    field.removeAttribute("aria-invalid")

    const errorEl = group.querySelector(".field-error")
    if (errorEl) errorEl.remove()
  }
}
